function toggleModal(event) {
  event.preventDefault();
  const data = event.currentTarget.dataset.link;
  const element = document.querySelector(`[data-modal="${data}"]`);

  if (!element.classList.contains('is-active')) {
    element.classList.add('is-active');
  } else {
    element.classList.remove('is-active');
  }
  document.querySelector('#specials-container').click();
}

function init() {
  const toggleElements = document.querySelectorAll('[data-link]');
  if (toggleElements) {
    toggleElements.forEach((el) => {
      el.addEventListener('click', toggleModal);
    });
  }
}

export default init();
